<template>
  <div>
    <v-card>
      <v-card-title>
        Locais
        <v-spacer />
        <v-btn color="#FF562B" @click="abrirDialog()" dark
          ><i class="mdi mdi-plus"></i>Novo local</v-btn
        >
      </v-card-title>
      <v-data-table :headers="headers" :items="locais" item-value="id" class="elevation-1">
        <template v-slot:[`item.acoes`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small color="default" v-bind="attrs" v-on="on" @click="abrirDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="solicitarExclusao(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para criar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ localSelecionado.id ? 'Editar' : 'Nova' }} Local</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="localSelecionado.name"
              label="Nome do Local"
              :rules="[v => !!v || 'Campo obrigatório']"
              required
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="fecharDialog">Cancelar</v-btn>
          <v-btn
            color="#FF562B"
            @click="
              {
                {
                  localSelecionado.id ? editarLocal(localSelecionado.id) : salvarLocal();
                }
              }
            "
            dark
            ><i class="mdi mdi-content-save"></i>Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AlertaModal v-model="mostrarAlerta" titulo="Validação" :mensagem="mensagemAlerta" />
    <ConfirmDialog
      :value="confirmDialogVisible"
      @input="confirmDialogVisible = $event"
      :message="`Tem certeza que deseja excluir o item '${itemSelecionado?.name}'?`"
      @confirm="confirmarExclusao"
    />
  </div>
</template>

<script>
import {
  getLocations,
  storeLocation,
  deleteLocation,
  updateLocation,
} from '../../services/estoque/local-servico';
import AlertaModal from '../Modais/AlertaModal.vue';
import ConfirmDialog from '../Modais/ConfirmDialog.vue';

export default {
  components: { AlertaModal, ConfirmDialog },
  data() {
    return {
      dialog: false,
      mostrarAlerta: false,
      mensagemAlerta: '',
      confirmDialogVisible: false,
      itemSelecionado: null,
      locais: [],
      localSelecionado: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Ações', value: 'acoes', sortable: false },
      ],
    };
  },
  mounted() {
    this.carregarLocais();
  },
  methods: {
    async carregarLocais() {
      this.locais = await getLocations();
    },
    abrirDialog(categoria = {}) {
      this.localSelecionado = { ...categoria };
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
      this.localSelecionado = {};
    },
    async salvarLocal() {
      const form = this.$refs.form;
      if (form && form.validate()) {
        await storeLocation(this.localSelecionado);
        this.fecharDialog();
        this.carregarLocais();
      }
    },
    async editarLocal(localId) {
      const form = this.$refs.form;
      if (form && form.validate()) {
        await updateLocation(localId, this.localSelecionado);
        this.fecharDialog();
        this.carregarLocais();
      }
    },

    solicitarExclusao(item) {
      this.itemSelecionado = item;
      this.confirmDialogVisible = true;
    },

    async confirmarExclusao() {
      try {
        await deleteLocation(this.itemSelecionado.id);
        this.carregarLocais();
        this.itemSelecionado = null;
      } catch (e) {
        console.error('Erro ao excluir:', e);
        this.mostrarAlerta = true;
        this.mensagemAlerta = 'Existem itens vinculados a esse local. Exclua-os primeiro.';
      }
    },
  },
};
</script>
